import React, { PropsWithChildren, useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { WebAppStoreButtons } from "@/components/WebAppStoreButtons";

const styles = StyleSheet.create({
  aestheticLink: {
    marginTop: 40,
  },
});

interface Props {
};

export function AllHomepagesFooter({ }: Props) : React.ReactNode {
  return (
    <>
      <Link href="/aesthetic" style={styles.aestheticLink}>
        <CustomText type='link'>
          𝕒𝕖𝕤𝕥𝕙𝕖𝕥𝕚𝕔?    (◔◡◔)
          {/*AppUtilities.stringToFullWidth("𝕨𝕙𝕒𝕥'𝕤 𝕥𝕙𝕚𝕤 𝕒𝕖𝕤𝕥𝕙𝕖𝕥𝕚𝕔?")*/}
          {/*AppUtilities.stringToFullWidth("what's    this    aesthetic?")*/}
        </CustomText>
      </Link>

      <WebAppStoreButtons />
    </>
  );
};
